import * as React from 'react';
import clsx from 'clsx';

import { getThemeCss } from 'components/Themes';
import { BookingWidgetThemeContext } from 'contexts/BookingWidgetThemeContext';

interface OwnProps {
  tags: string[];
}

type Props = OwnProps;

export const TagList = ({ tags }: Props) => {
  const bookingWidgetTheme = React.useContext(BookingWidgetThemeContext);

  return (
    <ul className={clsx('c-tag', getThemeCss(bookingWidgetTheme, 'c-tag'))}>
      {tags.map((tag) => (
        <li key={tag}>
          <a>{tag}</a>
        </li>
      ))}
    </ul>
  );
};
